import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { X } from "lucide-react";

export const AdBanner = ({ placement = "dashboard" }) => {
  const [ads, setAds] = useState([]);
  const [closed, setClosed] = useState(false);

  useEffect(() => { api.get(`/ads?placement=${placement}`).then((r) => setAds(r.data)).catch(() => {}); }, [placement]);

  if (closed || ads.length === 0) return null;
  const ad = ads[0];

  const Wrapper = ad.link_url ? "a" : "div";
  const props = ad.link_url ? { href: ad.link_url.startsWith("http") ? ad.link_url : `https://${ad.link_url}`, target: "_blank", rel: "noreferrer" } : {};

  return (
    <div data-testid="ad-banner" className="relative rounded-2xl border border-accent/30 bg-gradient-to-r from-accent/10 to-primary/5 overflow-hidden mb-6">
      <button data-testid="ad-close" onClick={() => setClosed(true)} className="absolute top-2 right-2 z-10 p-1 rounded-full bg-card/80 text-muted-foreground hover:text-foreground"><X className="h-3.5 w-3.5" /></button>
      <Wrapper {...props} className="flex items-center gap-4 p-4">
        {ad.image && <div className="h-16 w-16 rounded-xl overflow-hidden bg-muted shrink-0"><img src={ad.image} alt={ad.title} className="h-full w-full object-cover" /></div>}
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2"><span className="text-[10px] uppercase tracking-wide text-muted-foreground bg-muted px-1.5 py-0.5 rounded">Ad</span>{ad.advertiser && <span className="text-xs text-muted-foreground">{ad.advertiser}</span>}</div>
          <div className="font-head font-semibold mt-0.5">{ad.title}</div>
          {ad.description && <div className="text-sm text-muted-foreground truncate">{ad.description}</div>}
        </div>
      </Wrapper>
    </div>
  );
};
